module.exports = __webpack_public_path__ + "img/we-wish-you-a-merry-christmas-image.935df089.jpg";